// extracted by mini-css-extract-plugin
module.exports = {"user-layout-content":"style_user-layout-content__sW4j2"};